
import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const Addphotosectionsocial = () =>{
    const [name, setName] = useState('');
    let navigt = useNavigate();
    const handleImage =(e)=>{
        setName(e.target.files[0]) 
    }
    const  formSubmit = (e)=>{
        e.preventDefault()
        const formData = new FormData()
        formData.append('name', name)
 
        axios.post('https://backend.dasta.net/api/auth/addphotoourworksocialsection',formData).then((res)=>{
            console.log(res)
        }).then((data)=>{
            navigt(-1);
        })
    }  

    return(
        <>
        <h1 style={{ color: 'white', width:'20%', margin: '0px auto'}} >Social Media</h1>

        <form onSubmit={formSubmit}>
            <input type="file" name="file" onChange={(e)=>setName(e.target.files[0])}/>
            <button type='submit' >submit</button>
        </form>
        </>
    )

}
export default Addphotosectionsocial;